import { GET_CHAPTER_DATA, GET_LESSON_DATA, DELETE_LESSON_DATA,DRAG_LESSON_DATA, EDIT_LESSON_DATA, ADD_CHAPTER, REPLACE_LESSON_DATA,GET_LESSONS_DATA, GET_SINGLE_LESSON, DELETE_CHAPTER, GET_SINGLE_CHAPTER, EDIT_CHAPTER, ADD_LESSON } from "../actions/types"

const initialState = {
    data: [],
    lessons: [],
    chapter: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CHAPTER_DATA:
            return {
                ...state,
                data: action.payload
            };
        case GET_LESSON_DATA:
            return {
                ...state,
                lessons: action.payload
            };
            case GET_LESSONS_DATA:
                return{
                    ...state,
                    lessons: action.payload
                }
        case DELETE_LESSON_DATA:
            return {
                ...state,
            };
        case EDIT_LESSON_DATA:
            return {
                ...state,
                lessons: action.payload
            };
        case ADD_CHAPTER:
            return {
                ...state,
                data: action.payload
            };
        case DELETE_CHAPTER:
            return {
                ...state,
            };
        case EDIT_CHAPTER:
            return {
                ...state,
            };
        case ADD_LESSON:
            return {
                ...state,
                lesson: action.payload
            };
        case GET_SINGLE_CHAPTER:
            return {
                ...state,
                chapter: action.payload
            };
        case GET_SINGLE_LESSON:
            return {
                ...state,
                chapter: action.payload
            };
        case REPLACE_LESSON_DATA: {
            return {
                ...state
            }
        } 
        case DRAG_LESSON_DATA: {
            return {
                ...state
            }
        } 
        default:
            return state
    }
}